import { Component, OnInit, Input, Output, OnChanges, EventEmitter, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.css']
})
export class CustomerSearchComponent implements OnInit, OnChanges {
  @Output('client') chosen = new EventEmitter <singleCustomer>();
  @Input('options') options = new CustomerSearchOutputOptions();
  @Input('inputId') inputId: string = '';
  @Input('customerId') customerId: string;
  @ViewChild('searchCustomerModal') searchCustomer: ElementRef;
  allClients: Array<Customer> = [];
  output: Array<Customer> = [];
  who: string = '';
  gettingCustomers = false;
  offset = -240;
  chosenClient: singleCustomer = null;
  isSearching = false;
  viewAmount = 60;

  startIndex = 0;
  endIndex = 50;
  scrollDistance = 1;
  scrollUpDistance = 2;
  throttle = 150;

  constructor(private httpClient: HttpClient) { }

  ngOnInit() {
    this.getCustomersPagination(this.startIndex, this.endIndex);
  }

  close() {
    this.searchCustomer.nativeElement.click();
    this.isSearching = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes.customerId && changes.customerId.currentValue != null) {
        //console.log('getting client', changes.customerId.currentValue)
      this.getClientById(changes.customerId.currentValue)
    }
  }

  async search() {
    if (this.who != '') { this.getCustomerSearch() }
    else { this.getCustomersPagination(0,80) }
  }

  restrictViewAmount(array) {
    if (array.length > this.viewAmount) {
      this.output = array.slice(0, this.viewAmount)
    }
    else { this.output = array }
  }

  chooseClient(client: Customer) {
    if (client != null) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        this.httpClient.get(api.jubloApi + 'api/Website/Customer/GetCustomerById/' + client.customerId, { headers }).subscribe((data: singleCustomer) => {
            this.chosen.emit(data);
            this.chosenClient = data;
      });
      this.output = [];
      this.who = client.name;
    }
  }

  getClientById(id) {
      if (id != null) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.get(api.jubloApi + 'api/Website/Customer/GetCustomerById/' + id, { headers }).subscribe((data: singleCustomer) => {
        this.chosen.emit(data);
        this.chosenClient = data;
        this.who = data.customerName;
      });
      this.output = [];
    }
  }

  getCustomersPagination(start, stop) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Customer/GetCustomersPagination/' + start.toString() + '/' + stop.toString(), {headers}).subscribe(
      (data: Array<Customer>) => {
        this.output = data
      } 
    )
  }

  getCustomerSearch() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Customer/GetCustomersSearch/' + this.who + '/60', { headers }).subscribe(
      (data: Array<Customer>) => { this.output = data }
    )

  }

  onScrollDown() {
    console.log('scrolling')
    this.startIndex += 25;
    this.endIndex += 25;
    this.getCustomersPagination(this.startIndex, this.endIndex);
  }
}

export class Customer {
  customerId: string = '';
  customerGroup: string = '';
  externalId: string = '';
  name: string = '';
  customerAddress: string = '';
  customerZipCode: string = '';
  customerCity: string = '';
  customerPhone: string = '';
  customerMobile: string = '';
  customerEmail: string = '';
  invoiceName: string = '';
  invoiceAddress: string = '';
  invoiceZipCode: string = '';
  invoiceCity: string = '';
  invoicePhone: string = '';
  invoiceMobile: string = '';
  invoiceEmail: string = '';
  customerNumber: string = '';
}

export class DeliveryAddress {
  deliveryId: string;
  customerName: string;
  customerAddress: string;
  customerZipCode: string;
  customerCity: string;
  customerPhone: string;
  customerMobile: string;
  customerMail: string;
  ean?: string;
  att?: string;
}

export class CustomerSearchOutputOptions {
  offset: number = 0;
  maxHeight: number = 70;
  bottom: number = null;
  preselected: string = null;
  showResult: boolean = true;
  onlySearch: boolean = false;
}

export class singleCustomer {
  att: string;
  cvr: string;
  ean: string;
  contactAddresse: Array<ContactAddress>;
  customerId: string;
  deliveryId: string;
  contactId: string;
  customerGroup: string;
  customer: string;
  customerNumber:string;
  customerName: string;
  customerAddress: string;
  customerZipCode: string;
  customerCity:string;
  customerPhone: string;
  customerMobile: string;
  customerMail: string;
  externalId: string;
  invoiceName: string;
  invoiceAddress: string;
  invoiceZipCode: string;
  invoiceCity: string;
  invoicePhone: string;
  invoiceMobile: string;
  invoiceEmail: string;
  addresses: Array<DeliveryAddress>;
  propertyInfo: Array<any>;
}

export class ContactAddress {
  id: string;
  name: string;
  address: string;
  city: string;
  zipCode: string;
  phone: string;
  mobile: string;
  fax: string;
  email: string;
  ean: string;
  att: string;
  cvr: string;
}
